export default {
    baseURI:'/lhnServiceApi', // 接口地址前缀
    signApi: '/serviceScrmApi/wechat/api/adleading/wechat/web/getSignature',
    appid:'wx529bd2a8870effe2'
}
